import styled from 'styled-components'

export const StickyOnTop = styled.section`
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: inherit;
`
